module.exports = __webpack_public_path__ + "img/2-low.e83a57bf.jpg";